import React from 'react';
import { ReferenceInput, ReferenceArrayInput, useTranslate } from 'react-admin';

import { getSeasonDisplayName } from '@hisports/common/src/seasons';

import { useFormSeason } from '../../common/inputs/SeasonSelector';
import AutocompleteInput from '../../common/inputs/AutocompleteInput';
import AutocompleteSuggestion from '../../common/inputs/AutocompleteSuggestion'

import { usePermissions, useSport } from '../../http';

import { ScheduleIcon } from '../icons';

const filterSchedules = filter => name => ({ ...filter, name })

const ScheduleSuggestion = ({ suggestion: schedule, query, isHighlighted, ...props }) => {
  const sport = useSport();
  const translate = useTranslate();

  if (!schedule?.id) return null;
  const season = getSeasonDisplayName(schedule.seasonId, sport);
  return <AutocompleteSuggestion icon={<ScheduleIcon />} primary={schedule.name} secondary={`${translate(`resources.schedules.values.type.${schedule.type}`)} (${season}) - ${schedule.office.name}`} />
}

export const ScheduleInput = ({ allowEmpty, multiple, helperText, needDirectAccess = true, ...props }) => {
  const permissions = usePermissions();
  const seasonId = useFormSeason();
  const officeIds = [];
  const scheduleIds = [];

  const isInternal = permissions.some(p => {
    if (p.roleType === 'System') return true;
    return false
  })

  if (needDirectAccess) {
    permissions
      .filter(p => !p.inherited || p.parentInherited)
      .forEach(p => {
        const hasOfficeScope = ['Office'].includes(p.roleType) && p.scopes.includes("scheduling:manage");
        const hasScheduleScope = ['Schedule'].includes(p.roleType) && p.scopes.includes("scheduling:manage");
        if (hasOfficeScope) {
          officeIds.push(...p.officeIds);
        }
        if (hasScheduleScope) {
          scheduleIds.push(...p.scheduleIds);
        }
      });
  }

  const filterToQuery = isInternal || !needDirectAccess
    ? filterSchedules({ seasonId, pastEvents: true, _include: 'office' })
    : filterSchedules({
      seasonId,
      pastEvents: true,
      or: [
        { officeId: { inq: officeIds } },
        { id: { inq: scheduleIds } }
      ],
      effectiveOffices: false,
      _include: 'office'
    });

  const Input = multiple ? ReferenceArrayInput : ReferenceInput;
  return <Input
    reference="schedules"
    filterToQuery={filterToQuery}
    sort={{
      field: ['type', 'name'],
      order: ['ASC', 'ASC'],
    }}
    perPage={100}
    {...props}
  >
    <AutocompleteInput
      optionText="name"
      groupBy={schedule => schedule.type}
      suggestionComponent={ScheduleSuggestion}
      multiple={multiple}
      helperText={helperText}
      resettable
      allowEmpty
    />
  </Input>
}
